import { useMutation } from '@tanstack/react-query';

import { apiRequest } from 'src/helpers/apiRequest';
import { useAppConfig } from 'src/hooks';
import { TenantCreateRequest, TenantResponse } from 'src/types/rest/tenant';

export const useCreateTenant = () => {
  const {
    tenancy: { apiHost },
  } = useAppConfig();

  return useMutation({
    mutationFn: (variables: TenantCreateRequest) =>
      apiRequest<TenantResponse>({
        data: variables,
        method: 'POST',
        url: `${apiHost}/tenants`,
      }),
  });
};
